import { render, staticRenderFns } from "./WannasornAdditionalCourseInfoManager.vue?vue&type=template&id=972195ee&scoped=true"
import script from "./WannasornAdditionalCourseInfoManager.vue?vue&type=script&lang=js"
export * from "./WannasornAdditionalCourseInfoManager.vue?vue&type=script&lang=js"
import style0 from "./WannasornAdditionalCourseInfoManager.vue?vue&type=style&index=0&id=972195ee&prod&lang=scss&scoped=true"
import style1 from "./WannasornAdditionalCourseInfoManager.vue?vue&type=style&index=1&id=972195ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972195ee",
  null
  
)

export default component.exports